// @flow
import client from '../../client'
import format, { formatTwoDigits } from '../../utils/format'

// API Endpoints
export const GET_REPORT_ENDPOINT = '/travel_agent/reports/{0}/{1}/{2}/{3}/'

/**
 * Downloads a report by opening its URL
 * @param {Object} data Report information
 * @param {string} data.start_month Starting month
 * @param {string} data.start_year Starting year
 * @param {string} data.end_month End month
 * @param {string} data.end_year End year
 * @param {boolean} data.travel_date Travel date or Booking date
 * @param {boolean} data.include_withdrawn Include withdrawn reservations or not
 * @return void
 */
export const downloadReport = (data: {
  start_month: string,
  start_year: string,
  end_month: string,
  end_year: string,
  travel_date: boolean,
  include_withdrawn: boolean,
}): Promise<any> => {
  const {
    start_month,
    start_year,
    end_month,
    end_year,
    include_withdrawn,
  } = data
  const endpoint = format(
    GET_REPORT_ENDPOINT,
    formatTwoDigits(start_month),
    start_year,
    formatTwoDigits(end_month),
    end_year
  )

  return client
    .get(endpoint, {
      query: { travel_date: data.travel_date ? '1' : '0', include_withdrawn },
    })
    .then((res) => {
      window.open(res.url, '_blank')
    })
}

export default downloadReport
